import React, { useEffect, useRef, useState } from "react";
import ClientLogo from "./ClientLogo";
import NewsEvent from "./NewsEvent";
import { StartConversation } from "./StartConversation";
import { Testimonials } from "./Testimonials";

import cylontechnology1 from "../../images/casinoengine/spinlogo.png";
import cylontechnology from "../../images/casinoengine/cylontechnology.webp";

function Casinoengine(props) {
  const { changeActiveTab } = props;
  const wrapperRef = useRef(null);
  const draggerRef = useRef(null);
  const imageRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseMove = (e) => {
    if (!isDragging || !wrapperRef.current || !imageRef.current) return;

    const wrapper = wrapperRef.current;
    const image = imageRef.current;

    const bounds = wrapper.getBoundingClientRect();
    let offsetX = e.clientX - bounds.left;

    offsetX = Math.max(0, Math.min(offsetX, bounds.width));
    image.style.width = `${offsetX}px`;
    draggerRef.current.style.left = `${offsetX}px`;
  };

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  const data = [
    {
      image:
        "https://everymatrix.com/wp-content/uploads/2019/04/more-games-and-more-possibilities.svg",
      alt: "MORE GAMES AND MORE POSSIBILITIES ",
      url: "https://everymatrix.com/casinoengine/casino-content/",
      title: "Broadened Game Selection and Opportunities",
      description:
        "CasinoEngine offers seamless access to over 27,800 casino games from more than 317 game providers.",
      gaClick: "explore-more-games-and-more-possibilities",
      tab: 1,
    },
    {
      image:
        "https://everymatrix.com/wp-content/uploads/2019/04/full-featured-back-office.svg",
      alt: "Tailored business setups ",
      url: "https://everymatrix.com/casinoengine/business-models/",
      title: "Customizable Business Setups",
      description:
        "From premium content to a full turnkey casino platform, we offer tailored business setups to meet client needs.",
      gaClick: "explore-tailored-business-setups",
      tab: 2,
    },
    {
      image:
        "https://everymatrix.com/wp-content/uploads/2019/04/modular-platform-architecture.svg",
      alt: "Casino Platform Features",
      url: "https://everymatrix.com/casinoengine/platform-solution/",
      title: "Features of the Casino Platform",
      description:
        "CasinoEngine provides a fully-managed, robust casino platform solution tailored to clients’ needs.",
      gaClick: "explore-casino-platform-features",
      tab: 3,
    },
    {
      image:
        "https://everymatrix.com/wp-content/uploads/2019/05/multi-jurisdictional-gambling-compliance.svg",
      alt: "Compliant in Multiple Jurisdictions",
      title: "Regulatory Compliance in Multiple Jurisdictions",
      description:
        "CasinoEngine is certified in various jurisdictions and continuously adapts to meet regulatory frameworks.",
      url: "https://everymatrix.com/casinoengine/compliance/",

      gaClick: "explore-compliant-in-multiple-jurisdictions",
      tab: 4,
    },
    {
      image:
        "https://everymatrix.com/wp-content/uploads/2019/04/dedication-to-excellent-service-level.svg",
      alt: "Excellent Service Level",
      title: "Dedicated Service Excellence",
      description:
        "CasinoEngine provides ongoing account management and support, maintaining strong vendor integrations.",
      url: "https://everymatrix.com/casinoengine/service/",
      gaClick: "explore-excellent-service-level",
      tab: 5,
    },
  ];

  const logos = [
    {
      url: "https://everymatrix.com/clients/bet-at-home/",
      img: "https://everymatrix.com/wp-content/uploads/2021/07/Frame.svg",
      alt: "bet-at-home",
    },
    {
      url: "https://everymatrix.com/clients/tipico/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/tipico-1.svg",
      alt: "Tipico",
    },
    {
      url: "https://everymatrix.com/clients/opap/",
      img: "https://everymatrix.com/wp-content/uploads/2020/08/pngegg-1.png",
      alt: "OPAP",
    },
    {
      url: "https://everymatrix.com/clients/norsk-tipping/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/Frame-2.svg",
      alt: "Norsk Tipping",
    },
    {
      url: "https://everymatrix.com/clients/szerencsejatek-zrt/",
      img: "https://everymatrix.com/wp-content/uploads/2023/01/szerencsejatek.svg",
      alt: "Szerencsejáték ZRT",
    },
    {
      url: "https://everymatrix.com/clients/veikkaus/",
      img: "https://everymatrix.com/wp-content/uploads/2022/10/veikkaus-logo.png",
      alt: "Veikkaus",
    },
    {
      url: "https://everymatrix.com/clients/pinnacle/",
      img: "https://everymatrix.com/wp-content/uploads/2024/10/image-60.png",
      alt: "Pinnacle",
    },
    {
      url: "https://everymatrix.com/clients/intralot/",
      img: "https://everymatrix.com/wp-content/uploads/2022/09/Frame-36.svg",
      alt: "Intralot",
    },
    {
      url: "https://everymatrix.com/clients/flutter-entertainment/",
      img: "https://everymatrix.com/wp-content/uploads/2019/12/Group-3.svg",
      alt: "Flutter Entertainment",
    },
    {
      url: "https://everymatrix.com/clients/betparx/",
      img: "https://everymatrix.com/wp-content/uploads/2023/10/betparx.svg",
      alt: "betPARX",
    },
    {
      url: null,
      img: "https://everymatrix.com/wp-content/uploads/2024/11/BetGoodwinLogoNew-2-1-3.png",
      alt: "Private: betgoodwin",
    },
    {
      url: "https://everymatrix.com/clients/malta-national-lottery/",
      img: "https://everymatrix.com/wp-content/uploads/2022/07/national-lottery.svg",
      alt: "Malta National Lottery",
    },
  ];

  return (
    <>
      <section className="product-overview sec-padd pb-5 grayp" id="explore">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="section-title">Why CasinoEngine?</h2>
              <div className="row">
                <div className="col-md-8 mx-auto">
                  <p className="description">
                    CasinoEngine is a flexible, modular product that is not tied
                    to any specific platform. It can be integrated with
                    third-party platforms and wallets or fully managed through
                    our Gaming Management Platform, GamMatrix.
                  </p>
                </div>
              </div>
              <div className="inner">
                <ul>
                  <li>
                    <span>
                      Increases revenue, <br />
                      operational efficiency, and game selection
                    </span>
                  </li>
                  <li>
                    <span>
                      Modular and scalable <br />
                      API architecture
                    </span>
                  </li>
                  <li>
                    <span>
                      Drives customer satisfaction <br />
                      and enhance user experience
                    </span>
                  </li>
                  <li>
                    <span>
                      Flexible Front-end development <br />
                      and full-featured Back Office
                    </span>
                  </li>
                  <li>
                    <span>
                      Licensed and certified <br />
                      in several jurisdictions
                    </span>
                  </li>
                  <li>
                    <span>
                      Unified Bonus System to drive <br />
                      acquisition and retention
                    </span>
                  </li>
                  <li>
                    <span>
                      Dedicated Account Management <br />
                      and 24/7 Gaming Support
                    </span>
                  </li>
                  <li>
                    <span>
                      Integrates with 3rd party platforms,
                      <br /> wallets or turnkey solution{" "}
                    </span>
                  </li>
                  <li>
                    <span>
                      Ongoing Vendor <br />
                      Management
                    </span>
                  </li>
                  <li>
                    <span>
                      Flexible commercial models
                      <br /> and business setups
                    </span>
                  </li>
                </ul>
                <div className="horz-comparison">
                  <div className="cocoen" ref={wrapperRef}>
                    <div ref={imageRef}>
                      <img
                        src={cylontechnology1}
                        style={{ width: "750px" }}
                      />
                    </div>
                    <img src={cylontechnology} />
                    <span
                      className="cocoen-drag"
                      ref={draggerRef}
                      onMouseDown={handleMouseDown}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-summary sec-padd">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <h2 className="section-title">Explore CasinoEngine</h2>
            </div>
          </div>
          <div className="row justify-content-center">
            {data.map((feature, index) => (
              <div className="col" key={index}>
                <div
                  className="inner"
                  onClick={() => {
                    changeActiveTab(feature.tab);
                  }}
                >
                  <div className="img-holder">
                    <img src={feature.image} alt={feature.alt} />
                  </div>
                  <h3>
                    <a data-ga-click={feature.gaClick}>{feature.title}</a>
                  </h3>
                  <p>{feature.description}</p>
                  <a
                    // href={feature.url}
                    className="read-more"
                    // data-ga-click={feature.gaClick}
                  >
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <NewsEvent />
      <Testimonials />

      {/* <section className="product-clients sec-padd grayp">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="section-title">Our Clients</h2>
              <p>
                Servicing more than 300 operators from different jurisdictions,
                we are constantly <br />
                striving to offer our clients the best range of services, value
                and support in the market.
              </p>
              <ul className="list-clients row">
                {logos.map((logo, index) => (
                  <ClientLogo logo={logo} key={index} />
                ))}
              </ul>
              <div className="text-center">
                <a
                  className="btn btn_blue"
                >
                  View more clients
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <StartConversation />
    </>
  );
}

export default Casinoengine;
